import { Reveal } from "./Reveal";
import { CtaButton } from "./CtaButton";
import { VagasCounter } from "./VagasCounter";

export const Closing = () => (
  <section data-testid="closing-section" className="relative overflow-hidden bg-[var(--forest)] pb-24 md:py-32">
    {/* Mobile: professor no topo, fundindo com a seção */}
    <div className="absolute inset-x-0 top-0 h-[560px] md:hidden">
      <img src="/assets/frame_2.webp" alt="" className="h-full w-full object-cover object-[50%_30%]" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0f1f17]/10 via-transparent to-[#0f1f17]" />
    </div>
    {/* Desktop: arte completa, professor à esquerda */}
    <img src="/assets/frame_2.webp" alt="" data-testid="closing-bg" className="absolute inset-0 hidden h-full w-full object-cover object-[70%_center] md:block" />
    <div className="absolute inset-0 hidden bg-gradient-to-r from-transparent via-[#0f1f17]/45 to-[#0f1f17]/90 md:block" />
    <div className="absolute inset-x-0 bottom-0 hidden h-40 bg-gradient-to-b from-transparent to-[#0f1f17] md:block" />

    <div className="relative mx-auto grid max-w-6xl gap-12 px-5 pt-[440px] md:grid-cols-2 md:pt-0">
      <div aria-hidden className="hidden md:block" />
      <Reveal className="flex flex-col gap-7">
        <h2 data-testid="closing-mentor-text" className="font-display text-2xl leading-snug text-[var(--cream)] md:text-[2.1rem]">
          Aprenda com quem está dentro da Espiritualidade há mais de 40 anos, quem criou diversos projetos sociais e projetos de caridade em seu município, quem é líder religioso há mais de 15 anos e trabalha fazendo a caridade!
        </h2>
        <p className="text-base leading-relaxed text-[#f5f1e6]/85">
          As vagas são limitadas para garantir a qualidade da Comunidade. Garanta sua vaga agora, viva a Espiritualidade e viva a Umbanda, sua diversidade, com fundamento, respeito e amor.
        </p>
        <VagasCounter />
        <div><CtaButton testId="closing-cta-vitalicio" /></div>
        <div className="flex items-center gap-5 rounded-3xl border border-white/10 bg-[#0b1510]/45 p-5 backdrop-blur-md">
          <img src="/assets/caixa.webp" alt="Presente surpresa" className="w-14 animate-[float_6s_ease-in-out_infinite] md:w-16" />
          <p className="text-sm text-[#f5f1e6]/85">
            Ao fazer parte, você irá receber todos os bônus, suporte, plataformas e acompanhamento, tudo vitalício. Toda semana tem aula e cursos novos!
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
